<div class="cats-page">

  <div class="lx-page-header">
    <div>
      <p class="lx-page-eyebrow">{{ 'page.categories_eyebrow' | translate }}</p>
      <h2 class="lx-page-title">{{ 'page.categories_title' | translate }}</h2>
    </div>
    <button class="lx-btn lx-btn--primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
      <span class="material-symbols-outlined">add</span>
      {{ 'btn.add_category' | translate }}
    </button>
  </div>

  <div class="cats-grid" *ngIf="dataFound">
    <div class="cat-card" *ngFor="let item of category_arr" (click)="cat_details(item.id)">
      <div class="cat-img-wrap">
        <img class="cat-img" [src]="item.image.image_url" [alt]="item.name" />
      </div>
      <div class="cat-card-footer">
        <p class="cat-card-name">{{ item.name }}</p>
        <span class="material-symbols-outlined cat-card-arrow">arrow_forward_ios</span>
      </div>
    </div>
  </div>

  <div class="lx-empty" *ngIf="!dataFound">
    <div class="lx-empty-icon">
      <span class="material-symbols-outlined">category</span>
    </div>
    <h3>{{ 'empty.categories' | translate }}</h3>
    <p>{{ 'empty.categories_sub' | translate }}</p>
  </div>

</div>

<!-- ══════════════════════════════════════
     Add Category Modal
════════════════════════════════════════ -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="lx-modal-content">
      <div class="lx-modal-header lx-modal-header--row">
        <div>
          <p class="lx-modal-eyebrow">{{ 'page.categories_eyebrow' | translate }}</p>
          <h5 class="lx-modal-title">{{ 'btn.add_category' | translate }}</h5>
        </div>
        <button type="button" class="lx-modal-close" data-bs-dismiss="modal">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="lx-modal-body">
        <div *ngIf="!showUploadFile">
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'lbl.name' | translate }} *</label>
            <input [(ngModel)]="categoryName" type="text" class="lx-input" [placeholder]="'ph.category_name' | translate" />
            <span class="lx-field-error" *ngIf="categoryName == '' && submitted == 'true'">
              {{ 'err.cat_name_required' | translate }}
            </span>
          </div>
        </div>
        <div *ngIf="showUploadFile">
          <form [formGroup]="uploadForm">
            <div class="lx-field-group">
              <label class="lx-field-label">{{ 'lbl.image' | translate }}</label>
              <input (change)="uploadFile($event)" type="file" class="lx-input lx-file-input" />
            </div>
          </form>
        </div>
      </div>
      <div class="lx-modal-footer">
        <button type="button" class="lx-btn lx-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button *ngIf="!showUploadFile" (click)="addCategory()" type="button" class="lx-btn lx-btn--primary">
          {{ 'btn.continue' | translate }}
          <span class="material-symbols-outlined">arrow_forward</span>
        </button>
        <button *ngIf="showUploadFile" (click)="addCategoryImage()" data-bs-dismiss="modal" type="button" class="lx-btn lx-btn--primary">
          <span class="material-symbols-outlined">save</span>
          {{ 'btn.save_category' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
